import React, { useState } from "react";
import Plot from "react-plotly.js";
import { Spin, Alert } from "antd";
import { Layout, ScatterData } from "plotly.js";
import RequestViewModal from "../Request/RequestViewModal";
import { usePermissions } from "../../PermissionsProvider";

// Legacy interface for backward compatibility
export interface ChartData {
  data: Array<ScatterData>;
  layout: Partial<Layout>;
}

interface SemanticChartProps {
  data: ChartData | null;
  loading: boolean;
  error: string | null;
}

const chartStyles = {
  wrapper: {
    background: "white",
    borderRadius: "8px",
    padding: "16px",
    height: "500px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  plotContainer: {
    width: "100%",
    height: "100%"
  }
};

export const SemanticChart: React.FC<SemanticChartProps> = ({
  data: figure,
  loading,
  error
}) => {
  const { apiKey } = usePermissions();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState<{
    requestId: string;
    applicationId: string;
    applicationActionId: string;
  } | null>(null);

  if (loading) {
    return (
      <div style={chartStyles.wrapper}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={chartStyles.wrapper}>
        <Alert
          message="Error Loading Chart"
          description={error}
          type="error"
          showIcon
        />
      </div>
    );
  }

  if (!figure) {
    return (
      <div style={chartStyles.wrapper}>
        <Alert
          message="No Data Available"
          description="There is no data to display in the chart"
          type="info"
          showIcon
        />
      </div>
    );
  }

  return (
    <div style={chartStyles.wrapper}>
      <Plot
        data={figure.data}
        layout={figure.layout}
        style={chartStyles.plotContainer}
        config={{
          responsive: true,
          displayModeBar: false
        }}
        onClick={(event: any) => {
          const point = event.points[0];
          if (!point) return;

          // customdata contains [requestId, applicationId, applicationActionId, intent, summary, tags]
          const [requestId, applicationId, applicationActionId] = point.customdata || [];
          if (requestId && applicationId && applicationActionId) {
            setSelectedRequest({
              requestId,
              applicationId: applicationId.toString(),
              applicationActionId: applicationActionId.toString()
            });
            setIsModalVisible(true);
          }
        }}
      />
      {selectedRequest && (
        <RequestViewModal
          requestId={selectedRequest.requestId}
          applicationId={selectedRequest.applicationId}
          applicationActionId={selectedRequest.applicationActionId}
          isVisible={isModalVisible}
          onClose={() => {
            setIsModalVisible(false);
            setSelectedRequest(null);
          }}
          apiKey={apiKey}
        />
      )}
    </div>
  );
}; 